import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom';
import Snackbars from './Snackbars';
import validator from 'validator';
import { useTranslation } from "react-i18next";
import axios from 'axios';

export default function RegisterVerifyOTPSignup(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const [smsotp, setSmsotp] = useState('123456');
    const [smsotp_error, setSmsotpError] = useState("");
    const [smstitle, setSmstitle] = useState('');
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success_msg, setSuccessMsg] = useState("");
    const [logo, setLogo] = useState("");

    useEffect(() => {
        if (window.sessionStorage.getItem("register_user_id") === null || window.sessionStorage.getItem("register_user_id") === undefined || window.sessionStorage.getItem("register_user_id") === "" || window.sessionStorage.getItem("register_user_id") === "null") {
            history.push('/register');
        }
        handleLoad();
        handlelogo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    const handlelogo = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }
        axios.get(process.env.REACT_APP_API_URL + 'getalllogo', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    console.log(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
                    setLogo(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
                }

            })
            .catch(function (error) {

            });
    }

    const handleLoad = () => {
        var jsonpar = JSON.stringify({
            'register_user_id': window.sessionStorage.getItem("register_user_id"),
        });
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }

        axios.post(process.env.REACT_APP_API_URL + 'getphonesms', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setSmstitle(res.data.phone_number);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }
            })
            .catch(function (error) {
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const validatesmsotp = (value) => {
        setSmsotp(value);
        if (!validator.isEmpty(value)) {
            if (!validator.isNumeric(value)) {
                setSmsotpError("Enter 6 digit Numbers Only");
                return false;
            } else {
                setSmsotpError("");
                return true;
            }

        } else {
            setSmsotpError(t('ERROR_MSG.SMS_OTP_VALIDATION'));
            return false;
        }
    }

    const sendsmsagain = () => {

        var jsonpar = JSON.stringify({
            'register_user_id': window.sessionStorage.getItem("register_user_id"),
        });
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }

        axios.post(process.env.REACT_APP_API_URL + 'sendagainsms', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setSuccess(true);
                    setSuccessMsg(t('ERROR_MSG.RESEND_SMS_SUCCESS'));
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }
            })
            .catch(function (error) {
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });

    }


    const handlesubmit = () => {
        if (validatesmsotp(smsotp) === false) {
            setSmsotpError(t('ERROR_MSG.SMS_OTP_VALIDATION'));
            return false;
        } else {
            setSmsotpError("");
            document.getElementById("submit").disabled = true;
            document.getElementById("submit").textContent = t('PROCESSING');
            var jsonpar = JSON.stringify({
                'smsotp': smsotp,
                'register_user_id': window.sessionStorage.getItem("register_user_id"),
            });
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            }

            axios.post(process.env.REACT_APP_API_URL + 'verifyotp', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        setSuccess(true);
                        setSuccessMsg(t('ERROR_MSG.GOTO_GOOGLE_AUTH'));
                        setTimeout(() => {
                            setSuccess(false);
                            history.push('/register-google-auth');
                        }, 1000);

                    } else {
                        document.getElementById("submit").disabled = false;
                        document.getElementById("submit").textContent = t('BUTTONS.SUBMIT');
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    }

                })
                .catch(function (error) {
                    document.getElementById("submit").disabled = false;
                    document.getElementById("submit").textContent = t('BUTTONS.SUBMIT');
                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });
        }
    }

    return (
        <div className="vh-100 login-main-page p-0">
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            <div className="row m-0 justify-content-center h-100 align-items-center">
                <div className="login-wrapper">
                    <div className="login-aside-right">
                        <div className="col-xl-12">
                            <div className="authincation-content">
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className="auth-form-1">
                                            <div className="mb-5">
                                                <Link to="#" className="login-logo1 logo-center">
                                                    <img src={logo} alt="" className='mb-4 logo' />
                                                </Link>
                                                <h4 className="text-white mb-1 text-center login-text">{t('OTP_VERIFICATION')}</h4>
                                                <div className="text-white mb-0 mt-4 text-center login-text">
                                                    <p>{t('SEND_SMS_TITLE')} {smstitle}</p>
                                                </div>
                                            </div>

                                            <div className='form-group position-relative text-left'>
                                                <label className='mb-2 text-white'>{t('LABEL.PHONE_OTP')}</label>
                                                <input type='text' onChange={(e) => validatesmsotp(e.target.value)} value={smsotp} className='form-control text-black text-left' placeholder={t('PLACEHOLDER.PLACEHOLDER_PHONE_OTP')} />
                                                <Link className="resend-code-link" onClick={sendsmsagain} to="#">{t('LINK.RESEND_CODE')}</Link>
                                                {smsotp_error !== "" ? <label className='text-red'>{smsotp_error}</label> : ""}
                                            </div>

                                            <div className='text-center mt-4'>
                                                <div className='text-center'>
                                                    <button type="button" id="submit" onClick={handlesubmit} className="btn btn-login-hover bg-white text-primary btn-block" > {t('BUTTONS.VERIFY')} </button>
                                                </div>
                                            </div>

                                            <div className='new-account mt-5'>
                                                <p className='text-white text-center'><Link className="text-white color-bg-link" to='/login'> {t('LINK.RETURN_LOGIN')} </Link> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}